"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ForceUpdateDraftInvoiceBodySchema = exports.ListOrdersResponseSchema = exports.ListOrderQuerySchema = exports.PrepayPayOrderResponseSchema = exports.OrderResponseSchema = exports.castToOrderStatus = exports.OrderStatusSchema = exports.OrderStatus = exports.PrepayPaymentStatusSchema = exports.PrepayPaymentStatus = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
const cast_1 = require("../../../utils/cast");
var PrepayPaymentStatus;
(function (PrepayPaymentStatus) {
    PrepayPaymentStatus["PAID"] = "PAID";
    PrepayPaymentStatus["REQUIRES_ACTION"] = "REQUIRES_ACTION";
    PrepayPaymentStatus["FAILED"] = "FAILED";
    PrepayPaymentStatus["PENDING"] = "PENDING";
})(PrepayPaymentStatus = exports.PrepayPaymentStatus || (exports.PrepayPaymentStatus = {}));
exports.PrepayPaymentStatusSchema = (0, core_1.StringUnion)([
    PrepayPaymentStatus.PAID,
    PrepayPaymentStatus.PENDING,
    PrepayPaymentStatus.FAILED,
    PrepayPaymentStatus.REQUIRES_ACTION,
]);
var OrderStatus;
(function (OrderStatus) {
    OrderStatus["DRAFT"] = "DRAFT";
    OrderStatus["PENDING"] = "PENDING";
    OrderStatus["PAID"] = "PAID";
    OrderStatus["VOID"] = "VOID";
})(OrderStatus = exports.OrderStatus || (exports.OrderStatus = {}));
exports.OrderStatusSchema = (0, core_1.StringUnion)([
    OrderStatus.DRAFT,
    OrderStatus.PENDING,
    OrderStatus.PAID,
    OrderStatus.VOID,
]);
exports.castToOrderStatus = (0, cast_1.castToEnum)(OrderStatus);
const OrderResponseFields = {
    teamId: core_1.IdSchema,
    campaignId: typebox_1.Type.Optional(core_1.IdSchema),
    startDate: typebox_1.Type.Optional(core_1.TimestampSchema),
    endDate: typebox_1.Type.Optional(core_1.TimestampSchema),
    paymentDate: typebox_1.Type.Optional(core_1.TimestampSchema),
    dueDate: core_1.TimestampSchema,
    orderDate: core_1.TimestampSchema,
    currency: core_1.CurrencySchema,
    budgetSpend: core_1.MoneySchema,
    serviceFee: core_1.MoneySchema,
    commissionFee: core_1.MoneySchema,
    voucherDiscount: core_1.MoneySchema,
    vat: core_1.MoneySchema,
    totalAmount: core_1.MoneySchema,
    status: exports.OrderStatusSchema,
    processor: typebox_1.Type.Optional(ruby_1.PaymentProcessorTypeSchema),
    processorRef: typebox_1.Type.Optional(ruby_1.PaymentProcessorRefSchema),
    voucherCode: typebox_1.Type.Optional(ruby_1.VoucherCodeSchema),
    ...core_1.ModelMetaFields,
};
exports.OrderResponseSchema = (0, core_1.StrictObject)(OrderResponseFields);
exports.PrepayPayOrderResponseSchema = (0, core_1.StrictObject)({
    ...OrderResponseFields,
    invoiceUrl: typebox_1.Type.Optional(typebox_1.Type.String()),
    paymentStatus: exports.PrepayPaymentStatusSchema,
    paymentClientSecret: typebox_1.Type.Optional(typebox_1.Type.String()),
});
exports.ListOrderQuerySchema = (0, core_1.createUnsortedPaginatedQuery)({
    ...core_1.DateFilterFields,
    status: typebox_1.Type.Optional(typebox_1.Type.Array(exports.OrderStatusSchema)),
});
exports.ListOrdersResponseSchema = (0, core_1.createUnsortedListResponseSchema)(exports.OrderResponseSchema);
exports.ForceUpdateDraftInvoiceBodySchema = (0, core_1.StrictObject)({
    start: core_1.TimestampSchema,
    end: core_1.TimestampSchema,
});
